import React from 'react';
import ReactDOM from 'react-dom';
import Router from './router.js';
// using react to render
ReactDOM.render(
  <Router />,
  document.getElementById('root')
);